import { render, staticRenderFns } from "./DashboardTable.vue?vue&type=template&id=93490a70&"
import script from "./DashboardTable.vue?vue&type=script&lang=js&"
export * from "./DashboardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93490a70')) {
      api.createRecord('93490a70', component.options)
    } else {
      api.reload('93490a70', component.options)
    }
    module.hot.accept("./DashboardTable.vue?vue&type=template&id=93490a70&", function () {
      api.rerender('93490a70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/dashboard/DashboardTable.vue"
export default component.exports